/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { TrainingFilter } from './TrainingFilter';

export type TrainingViewRequest = {
    trainingFilter?: TrainingFilter;
    exposeType?: TrainingViewRequest.exposeType;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
}

export namespace TrainingViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
